import { IInventoryPurchaseOrderDraftPropsBody, POStatusTypes } from "@/api_framework/api_modals/Inventory";
import { useInventoryPurchaseOrderPdfAPI } from "@/app/hooks/api_hooks/Inventory/PO/useInventoryPurchaseOrderPdfAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { UseFieldArrayReturn } from "react-hook-form";
import { IInventoryPurchaseOrderFormFields } from "..";
import POSubmitButton from "../POSubmitButton";
import { MdOutlineFileDownload } from "react-icons/md";
import { IoIosArrowRoundBack } from "react-icons/io";

interface IPOPDFPreviewProps {
  formData: IInventoryPurchaseOrderDraftPropsBody;
  setPDFView: Dispatch<SetStateAction<boolean>>;
  POProductsHook: UseFieldArrayReturn<IInventoryPurchaseOrderFormFields, "product_info", "id">;
  attachementFieldHook: UseFieldArrayReturn<
    IInventoryPurchaseOrderFormFields,
    "product_info" | "attachments" | "invoice_details.attachments",
    "id"
  >;
  onSubmit: (overrideNextPOStatus?: POStatusTypes) => void;
}

const POPDFPreview: React.FC<IPOPDFPreviewProps> = ({
  formData,
  setPDFView,
  POProductsHook,
  onSubmit,
  attachementFieldHook,
}) => {
  const { execute: generatePDF, downloadPDF, pdfURL } = useInventoryPurchaseOrderPdfAPI();

  const { getRouteKey } = useRouter();
  const { purchaseOrderDetails: PODetails } = useRouteInfo(getRouteKey("INVENTORY", "id"))?.routeState
    ?.state as IInventoryState;

  useEffect(() => {
    generatePDF(formData);
  }, []);

  const handleActionButton = (nextStatus?: POStatusTypes) => {
    if (nextStatus) {
      onSubmit(nextStatus);
    } else {
      onSubmit();
    }
  };

  return (
    PODetails && (
      <div>
        <div className="flex justify-between">
          <h3 className="mt-5 font-semibold text-sm text-[#1F1F23]">PDF Preview</h3>
          <button
            type="button"
            onClick={() => downloadPDF()}
            className="flex items-center gap-1 mt-5 font-medium text-blue-600 text-xs hover:text-blue-700"
          >
            <MdOutlineFileDownload className="w-4 h-4" />
            Download PDF
          </button>
        </div>
        <br />
        <div>{pdfURL ? <iframe src={pdfURL} width="100%" height="600px" title="PDF Viewer" /> : "Loading..."}</div>
        <br />
        <div className="right-5 bottom-0 fixed flex justify-end items-center gap-4 p-3 bg-white">
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleActionButton("draft");
            }}
            type="button"
            className="inline-flex justify-center items-center gap-1.5 h-8 px-4 rounded-lg font-medium text-xs whitespace-nowrap transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-[#F1F1F1] border border-gray-200 text-[#1F1F23] hover:bg-gray-200"
          >
            <IoIosArrowRoundBack className="w-4 h-4" />
            Go Back
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleActionButton();
            }}
            type="button"
            className="inline-flex justify-center items-center gap-1.5 h-8 px-4 rounded-lg font-medium text-xs whitespace-nowrap transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-black text-white hover:opacity-90"
          >
            Send To Vendor
          </button>
        </div>
      </div>
    )
  );
};

export default POPDFPreview;
